import { DocumentCard, Faq } from 'sections/Resources/FreightTemplates/CommercialInvoice/types';

export const documentsCardData: DocumentCard[] = [
  {
    id: 1,
    iconName: 'icon-files.svg',
    heading: 'Packing List',
    fileName: 'packing_list',
    url: '/resources/freight-templates/packing-list',
  },
  {
    id: 2,
    iconName: 'icon-files.svg',
    heading: 'Certificate of Origin',
    url: '/resources/freight-templates/certificate-of-origin',
    fileName: 'certificate_of_origin',
  },
  {
    id: 3,
    iconName: 'icon-files.svg',
    heading: 'Shipper\'s Letter of Instruction',
    url: '/resources/freight-templates/sli',
    fileName: "shipper's_letter_of_instruction",
  },
];

export const faq: Faq[] = [
  {
    id: "1",
    question: "What are the absolute must-haves on this document?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Don't overcomplicate it, but don't cut corners. You need the buyer and seller's full details, clear product descriptions (no vague codes), <a class='${cn('faq__answer-link')}' href='https://www.df-alliance.com/blog/what-are-harmonised-system-hs-codes-in-shipping-'>HS codes</a>, the currency, total value, Incoterms, and the Country of Origin. Miss one, and you’re looking at a delay.  
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "We already shipped the cargo. Can we fix a mistake on the invoice?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Technically, yes. But it’s a hassle. If you amend the value or description while the ship is on the water, customs might flag it as suspicious. You’ll likely need to write a formal letter explaining the error. Always try to fix it before the manifest is filed.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "Is it legally required for every single shipment?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Pretty much. Unless you are shipping documents or very low-value samples, customs will demand a commercial invoice to prove the value, even if that value is "for customs purposes only."
        </p>
      `
    ),
  },
];